import { Text, chakra } from "@chakra-ui/react"
import { colors } from "lib/theme"

export const MembersPrice = chakra(Text, {
  baseStyle: {
    mt: 0,
    textAlign: "center",
    borderRight: `1px solid ${colors.borderTertiary}`,
    fontSize: 1,
  },
})
export const NonMembersPrice = chakra(Text, {
  baseStyle: {
    mt: 0,
    textAlign: "center",
    fontSize: 1,
  },
})

export const PriceCopy = chakra(Text, {
  baseStyle: {
    mt: 0,
    fontWeight: 500,
  },
})

export const primaryPriceStyle = { fontWeight: 700, color: colors.content }
export const secondaryPriceStyle = {
  fontWeight: 500,
  color: colors.contentTertiary,
}
